import Axios from "axios";
import {
    SET_HRM_DEPARTMENT_LIST,
    UNSET_HRM_DEPARTMENT_LIST,
  } from "@/store/mutation-types";
import { saveUpdateHrmDepartment, getHrmDepartmentList } from "@/store/api";
// initial state
const state = {
  getHrmDepartmentList: [],
};

const getters = {
  getHrmDepartmentList(state) {
    return state.getHrmDepartmentList;
  },
};

const mutations = {
  [SET_HRM_DEPARTMENT_LIST](state, data) {
    state.getHrmDepartmentList = data;
  },
  [UNSET_HRM_DEPARTMENT_LIST](state) {
    state.getHrmDepartmentList = [];
  },

};

const actions = {

  saveUpdateHrmDepartment({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateHrmDepartment, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getHrmDepartmentList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmDepartmentList, data)
        .then(function (response) {
          commit('SET_HRM_DEPARTMENT_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_DEPARTMENT_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
